import script from "./CasinoLimits.vue?vue&type=script&setup=true&lang=js"
export * from "./CasinoLimits.vue?vue&type=script&setup=true&lang=js"

import "./CasinoLimits.vue?vue&type=style&index=0&id=ccec541e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccec541e"]])

export default __exports__